const groupTree_CN = {
  groupTree_confirm: '确定',
  groupTree_cancel: '取消',
  groupTree_interface_error: '请求接口异常!',
  groupTree_add_group: '新增组织',
  groupTree_edit_group: '修改组织',
  groupTree_insert_group: '插入组织',
  groupTree_group_detail: '组织详情',
  groupTree_delete_group: '删除组织',
  groupTree_basic_info: '基本信息',
  groupTree_contactpeople_info: '联系人信息',
  groupTree_server_address: '服务器地址',
  groupTree_account_info: '账户信息',
  groupTree_ticket_info: '收票信息',
  groupTree_most_server: '最多保留{num}个服务器地址',
  /**
   * 组织树操作
   */
  groupTree_select_group: '请先选择组织',
  groupTree_add: '新增',
  groupTree_edit: '修改',
  groupTree_detail: '详情',
  groupTree_insert: '插入',
  groupTree_delete: '删除',
  groupTree_confirm_title: '操作确认',
  groupTree_confirm_content: '删掉就没了,请谨慎下手!',
  groupTree_confirm_oktxt: '确认',
  /**
   * 公共校验
   */
  groupTree_number_validate: '请输入{digits}位数字',
  groupTree_chinese_validate: '请输入{digits}位中文',
  groupTree_numberAZ_validate: '请输入{num}位数字和字母(大写)',
  groupTree_phone_validate: '请输入正确的联系电话',
  groupTree_email_validate: '请输入正确的邮箱格式',
  groupTree_ipdomain_validate: '请输入正确的域名或IP',
  groupTree_port_validate: '请输入正确的端口号',
  /**
   * 基本信息
   */
  groupTree_group_name: '组织名称',
  groupTree_input_groupname: '请输入组织名称',
  groupTree_groupname_validate: '组织名称已存在',
  groupTree_group_type: '组织类型',
  groupTree_select_grouptype: '请选择组织类型',
  groupTree_company: '公司',
  groupTree_department: '部门',
  groupTree_personal: '个人',
  groupTree_company_fullname: '公司全称',
  groupTree_input_companyfullname: '请输入公司全称',
  groupTree_company_type: '公司类型',
  groupTree_select_companytype: '请选择公司类型',
  groupTree_limited_company: '有限公司',
  groupTree_limited_liabilitycompany: '股份有限公司',
  groupTree_individual_proprietorship: '独资企业',
  groupTree_partnership: '合伙企业',
  groupTree_individual_business: '个体工商户',
  groupTree_social_code: '统一社会信用代码',
  groupTree_input_socialcode: '请输入统一社会信用代码',
  groupTree_company_area: '所属地区',
  groupTree_company_address: '公司地址',
  groupTree_input_companyaddress: '请输入公司地址',
  groupTree_legal_person: '法定代表人',
  groupTree_input_legalperson: '请输入法定代表人',
  /**
   * 联系人信息
   */
  groupTree_contacts: '联系人',
  groupTree_input_contacts: '请输入联系人',
  groupTree_contact_number: '联系电话',
  groupTree_input_contactnumber: '请输入联系电话',
  groupTree_contact_area: '所属地区',
  groupTree_contact_address: '详细地址',
  groupTree_input_contactaddress: '请输入详细地址',
  groupTree_email: '邮箱',
  groupTree_input_email: '请输入邮箱',
  groupTree_remark: '备注',
  groupTree_input_remark: '请输入备注',
  /**
   * 服务器地址
   */
  groupTree_server_name: '服务器名称',
  groupTree_input_servername: '请输入服务器名称',
  groupTree_servername_validate: '该服务器名称已存在',
  groupTree_serverip_address: '服务器地址(域名/IP)',
  groupTree_input_serveraddress: '请输入服务器地址',
  groupTree_port: '端口号',
  groupTree_input_port: '请输入端口号',
  /**
   * 账户信息
   */
  groupTree_account_name: '户名',
  groupTree_input_accountname: '请输入户名',
  groupTree_bank_account: '银行账号',
  groupTree_input_bankaccount: '请输入银行账号',
  groupTree_deposit_bank: '开户银行',
  groupTree_input_depositbank: '请输入开户银行',
  groupTree_bank_branch: '支行名称',
  groupTree_input_bankbranch: '请输入支行名称',
  /**
   * 收票信息
   */
  groupTree_ticket_collector: '收票人',
  groupTree_input_ticketcollector: '请输入收票人',
  groupTree_account_number: '联系电话',
  groupTree_input_accountnumber: '请输入联系电话',
  groupTree_account_area: '所属地区',
  groupTree_account_address: '详细地址',
  groupTree_input_accountaddress: '请输入详细地址',
};

export default groupTree_CN;